import settings from '@/settings'
import algoliasearch from 'algoliasearch/lite'
import store from '@/store/index'

const _client = algoliasearch(
  settings.services.algolia.appId,
  settings.services.algolia.accessToken
)

const _searchAppClient = algoliasearch(
  settings.services.algolia.searchApp.appId,
  settings.services.algolia.searchApp.accessToken
)

const _getProductIndex = (sortBy) => {
  switch (sortBy) {
    case 'popularity':
      return store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.productIndexPopularity)
    case 'price':
      return store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.productIndexPrice)
    case 'price_desc':
      return store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.productIndexPriceDesc)
    case 'relevance':
    default:
      return store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.productIndexRelevance)
  }
}

export default {
  getProductIndex (sortBy) {
    const index = _getProductIndex(sortBy)
    return _client.initIndex(index)
  },
  getSearchAppProductIndex () {
    return _searchAppClient.initIndex(store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.searchApp.productIndexRelevance))
  },
  getClient () {
    return _client
  },
  getProductIndexName (sortBy) {
    return _getProductIndex(sortBy)
  },
  getQuerySuggestions ({ query, ...rest }) {
    return _client.initIndex(store.getters['locale/getLocalizedAlgoliaIndexName'](settings.services.algolia.productIndexSuggestions)).search(query, rest)
  },
  finalizeQueryParams ({ filters, ...rest }, { isPublic, isEmployee, isDiscountedPrice, isAffiliate }) {
    filters = filters || ''
    if (isPublic) {
      if (filters) filters = filters + ' AND '
      filters = filters + "'Public Store':'Yes'"
    }
    if (isAffiliate) {
      if (filters) filters = filters + ' AND '
      filters = filters + "'Affiliate Store':'Yes'"
    }
    if (isEmployee) {
      if (filters) filters = filters + ' AND '
      filters = filters + "'Employee Store':'Yes'"
    }
    if (isEmployee && isDiscountedPrice) {
      if (filters) filters = filters + ' AND '
      filters = filters + 'isDiscountedPrice:true'
    }
    return { filters, attributesToRetrieve: this.getAttributesToRetrieve({ isEmployee, isAffiliate }), ...rest }
  },
  getAttributesToRetrieve ({ isEmployee, isAffiliate }) {
    const attributesToRetrieve = ['*']
    if (!isEmployee) attributesToRetrieve.push('-Employee Price', '-ProductPrice.employeePrice')
    if (!isAffiliate) attributesToRetrieve.push('-Affiliate Price', '-ProductPrice.affiliatePrice')
    return attributesToRetrieve
  },
  finalizeFilters ({ filters, isPublic, isEmployee, isDiscountedPrice, isAffiliate }) {
    filters = filters || []
    if (isPublic && !filters.some(el => el[0] === "'Public Store':'Yes'")) {
      filters.push(["'Public Store':'Yes'"])
    }
    if (isAffiliate && !filters.some(el => el[0] === "'Affiliate Store':'Yes'")) {
      filters.push(["'Affiliate Store':'Yes'"])
    }
    if (isEmployee && !filters.some(el => el[0] === "'Employee Store':'Yes'")) {
      filters.push(["'Employee Store':'Yes'"])
    }
    if (isEmployee && isDiscountedPrice && !filters.some(el => el[0] === 'isDiscountedPrice:true')) {
      filters.push(['isDiscountedPrice:true'])
    }

    return filters
  }
}
